import { Button } from "app/components/shadcn/button";
import { Card, CardFooter, CardHeader } from "app/components/shadcn/card";
import { GoogleLogo } from "app/components/icons";

export default function LoginPage() {
  return (
    <div className="min-h-screen flex justify-center items-start md:items-center p-8">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <h2 className="text-xl font-semibold">Best Gifts</h2>
          <p className="text-sm text-gray-600">
            Discover the greatest gifts for your loved ones
          </p>
        </CardHeader>

        <CardFooter>
          <form action="/auth/google" method="get" className="w-full">
            <Button className="w-full justify-start gap-x-4" type={"submit"}>
              <GoogleLogo className={"max-h-full"} /> Sign in with Google
            </Button>
          </form>
        </CardFooter>
      </Card>
    </div>
  );
}
